<table
 (matSortChange)="onSortChange($event)"

  [dataSource]="dataSource"
  
  mat-table
  matSort
  style="width: 100%"
>
<!-- <ng-container matColumnDef="action">
  <th *matHeaderCellDef mat-header-cell mat-sort-header>
   N°
  </th>
  <td *matCellDef="let d; let i = index;" mat-cell> {{i+1}}</td>
</ng-container> -->





<ng-container matColumnDef="cateId">
  <th  *matHeaderCellDef mat-header-cell style="text-align: center;" >
   
     {{ "Identifiant de la classification" | translate }}  
  </th>
  <td width="10%" *matCellDef="let d" mat-cell style="text-align: center;">
    
  {{ d.cateId }} 
    </td>
</ng-container>




<ng-container matColumnDef="cateNm">
  <th *matHeaderCellDef mat-header-cell mat-sort-header>
    {{ "Nom de la classification" | translate }}
  </th>
  <td  width="30%" *matCellDef="let d" mat-cell  >{{ d.cateNm }}</td>
</ng-container>


<ng-container matColumnDef="cateNmEn">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>
      {{ "Nom de la classification en anglais" | translate }}
    </th>
    <td width="30%"*matCellDef="let d" mat-cell>{{ d.cateNmEn }}</td>
  </ng-container>
  

 
  <ng-container matColumnDef="action">
    <th *matHeaderCellDef mat-header-cell>
   
    </th>
    <td width="30%"*matCellDef="let d " mat-cell>
      <button type="button" mat-raised-button class="st-butt-plusinfo text-wrap" (click)="listprod(d)">{{'Liste des produits' | translate}}</button>
      <button type="button" mat-raised-button class="st-butt-plusinfo text-wrap" (click)="opendialogdetail(d)" style="margin:5px;">Details de la classification</button>

    </td>
  </ng-container>



 <!--  <ng-container *ngFor="let column of readColumns" [matColumnDef]="column">

    <th *matHeaderCellDef mat-header-cell mat-sort-header>
      {{ column | translate }}
    </th>
    
    <td *matCellDef="let type" mat-cell>
      {{ type[column] | typedValue | async }}
    </td>
  </ng-container> -->
  <tr  *matHeaderRowDef="readColumns" mat-header-row></tr>
  <tr  *matRowDef="let row; columns: readColumns" mat-row></tr> 
  
   


  
</table>

<app-empty-list-container [list]="dataSource.data" [withoutBorder]="true"></app-empty-list-container>
